// extracted by mini-css-extract-plugin
module.exports = {"textBox":"text-box-module--text-box--1OSOa","textContent":"text-box-module--text-content--1UJ7n"};